import { defineMessages } from '@jutro/locale';

export default defineMessages({
    noCancellationNotes: {
        id: 'gateway.views.cancellation-detail.No notes associated with this cancellation',
        defaultMessage: 'There are no notes associated with this cancellation.'
    }
});
